define.alias("shared/helpers/time-ago", "settings/helpers/time-ago");